import { render, staticRenderFns } from "./GIDan.vue?vue&type=template&id=2e3fa1ca&scoped=true"
import script from "./GIDan.vue?vue&type=script&lang=js"
export * from "./GIDan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3fa1ca",
  null
  
)

export default component.exports